import axios from "axios";

export const testHash = process.env.REACT_APP_HASH;

export const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL + "/api/v1/",
    headers: {"content-type": "application/x-www-form-urlencoded"},
    params: {testHash},
});